import revive_payload_client_4sVQNw7RlN from "/nuxtapp/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/nuxtapp/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/nuxtapp/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/nuxtapp/node_modules/nuxt/dist/app/plugins/payload.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/nuxtapp/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import plugin_vue3_YdLad5Mpq3 from "/nuxtapp/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.js";
import components_plugin_KR1HBZs4kY from "/nuxtapp/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/nuxtapp/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_w2VlvAEcpa from "/nuxtapp/node_modules/nuxt-bugsnag/dist/runtime/client/plugin.mjs";
import plugin_6oy0ulSF66 from "/nuxtapp/node_modules/nuxt-csurf/dist/runtime/plugin.mjs";
import wait_8smOKXbEa2 from "/nuxtapp/node_modules/maz-ui/nuxt/runtime/plugins/wait.js";
import toaster_075gpxZKPU from "/nuxtapp/node_modules/maz-ui/nuxt/runtime/plugins/toaster.js";
import aos_mKDFTpG042 from "/nuxtapp/node_modules/maz-ui/nuxt/runtime/plugins/aos.js";
import chunk_reload_client_UciE0i6zes from "/nuxtapp/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  check_outdated_build_client_8vK7RkfGxZ,
  plugin_vue3_YdLad5Mpq3,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  plugin_w2VlvAEcpa,
  plugin_6oy0ulSF66,
  wait_8smOKXbEa2,
  toaster_075gpxZKPU,
  aos_mKDFTpG042,
  chunk_reload_client_UciE0i6zes
]